// extracted by mini-css-extract-plugin
export default {"mainRow":"UploadImage_mainRow__koBHx","contentRow":"UploadImage_contentRow__+C+14","title":"UploadImage_title__URZJE","desc":"UploadImage_desc__Mf2Yl","img":"UploadImage_img__IifAi"};